function TimeHms(h = 0, min = 0, s = 0) {
    this.hour = h;
    this.minute = min;
    this.second = s;
}

export { TimeHms }